import { createReducer } from '@reduxjs/toolkit';
import {
  DEPENDENCY_CHECK_RESULT,
  DEPENDENCY_CHECKS_FINISHED,
  DEPENDENCY_CHECKS_STARTED,
} from './actions';
import { defaultState, namespace } from './store';

export const adminDependenciesReducer = {
  [namespace]: createReducer(defaultState, (builder) => {
    builder
      .addCase(DEPENDENCY_CHECKS_STARTED, (_state, { payload }) => ({
        status: 'running',
        startedAt: payload.startedAt,
        results: payload.results,
      }))
      .addCase(DEPENDENCY_CHECK_RESULT, (state, { payload }) => ({
        ...state,
        results: state.results.map((row) =>
          row.configKey === payload.configKey ? payload : row
        ),
      }))
      .addCase(DEPENDENCY_CHECKS_FINISHED, (state) => ({
        ...state,
        status: 'done',
      }));
  }),
};
